export default {
  viewData: 'VIEW DATA',
  viewChart: 'VIEW CHART',
  allTime: 'All Time',
  recentYear5: '5 Recent Years',
  recentYear10: '10 Recent Years',
  timeRange: 'Time Range:',
  from: 'From',
  to: 'to',
  present: 'Present',
  averageReturn: 'AVERAGE RETURN',
  daily: 'Daily',
  monthly: 'Monthly',
  quarterly: 'Quarterly',

  monday: 'Monday',
  tuesday: 'Tuesday',
  wednesday: 'Wednesday',
  thursday: 'Thursday',
  friday: 'Friday',

  january: 'January',
  february: 'February',
  march: 'March',
  april: 'April',
  may: 'May',
  june: 'June',
  july: 'July',
  august: 'August',
  september: 'September',
  october: 'October',
  november: 'November',
  december: 'December',

  quarter1: 'Quater 1',
  quarter2: 'Quater 2',
  quarter3: 'Quater 3',
  quarter4: 'Quater 4',

  q1: 'Q1',
  q2: 'Q2',
  q3: 'Q3',
  q4: 'Q4',

  listFilterDatetime: {
    day: 'Day',
    month: 'Month',
    quarter: 'Quarter',
  },

  marketAnomalyTable: {
    YEAR: 'YEAR',
    MONDAY: 'MONDAY',
    TUESDAY: 'TUESDAY',
    WEDNESDAY: 'WEDNESDAY',
    THURSDAY: 'THURSDAY',
    FRIDAY: 'FRIDAY',
    JANUARY: 'JANUARY',
    FEBRUARY: 'FEBRUARY',
    MARCH: 'MARCH',
    APRIL: 'APRIL',
    MAY: 'MAY',
    JUNE: 'JUNE',
    JULY: 'JURY',
    AUGUST: 'AUGUST',
    SEPTEMBER: 'SEPTEMBER',
    OCTOBER: 'OCTOBER',
    NOVEMBER: 'NOVEMBER',
    DECEMBER: 'DECEMBER',
    QUARTER_ONE: 'QUARTER 1',
    QUARTER_TWO: 'QUARTER 2',
    QUARTER_THREE: 'QUARTER 3',
    QUARTER_FOUR: 'QUARTER 4',
  },
  Average: 'Average',
};
